/**
 * Product filtering - filter types
 * @constant {object}
 * @default
 */
export const FILTER_TYPES = {
  SINGLE: 'SINGLE',
  MULTI: 'MULTI',
  RANGE: 'RANGE'
};

/**
 * Product filtering - filter event types
 * @constant {object}
 * @default
 */
export const FILTER_EVENT = {
  APPLY: 'APPLY',
  REMOVE: 'REMOVE',
  RESET: 'RESET',
  SORT: 'SORT',
  PAGINATION: 'PAGINATION',
  USER: 'USER',
  LOAD_PREVIOUS:'LOAD_PREVIOUS',
  LOAD_MORE:'LOAD_MORE',
  RESET_GROUP: 'RESET_GROUP'
};

/**
 * Product filtering - filter group types
 * @constant {object}
 * @default
 */
export const FILTER_GROUPS = {
  AVAILABLE_STORE_IDS: 'AVAILABLE_STORE_IDS',
  BRAND: 'BRAND',
  CATEGORIES: 'CATEGORIES',
  FRAGRANCE_TYPE: 'FRAGRANCE_TYPE',
  PRICE: 'PRICE',
  STATUS: 'STATUS',
  CHANNEL: 'CHANNEL',
  ON_SALE: 'ON_SALE',
  PART_OF_BODY: 'PART_OF_BODY',
  PROMOTION_TYPE: 'PROMOTION_TYPE',
  SHAVING_USE: 'SHAVING_USE',
  ASSOCIATION_TYPE: 'ASSOCIATION_TYPE',
  HAIR_EFFECT: 'HAIR_EFFECT',
  PROMOTION_ID: 'PROMOTION_ID',
  RATING: 'RATING',
  DATE: 'DATE'
};
/**
 * filter column - filter group id
 * @constant {string}
 * @default
 */
export const FILTER_GROUP_ID = 'filterGroup';
